import { combineReducers } from "redux"
// Event related reducers
import fetchEventsReducer from "./event/fetchEventsReducer"
import createEventReducer from "./event/createEventReducer"
import updateEventReducer from "./event/updateEventReducer"
import deleteEventReducer from "./event/deleteEventReducer"
import fetchEventDetailsReducer from "./event/fetchEventDetailsReducer"
import fetchEventTicketsReducer from "./event/fetchEventTicketsReducer"
import fetchEventTicketsExcelReducer from "./event/fetchEventTicketsExcelReducer"

// Auth related reducers
import getOTPReducer from "./getOTPReducer"
import loginReducer from "./loginReducer"
import signupReducer from "./signupReducer"
import getAdminDashboardDataReducer from "./getAdminDashboardDataReducer"
import getAllInvoicesReducer from "./getAllInvoicesReducer"

// Category related reducers
import fetchCategoriesReducer from "./event/fetchCategoriesReducer"
import createCategoryReducer from "./event/createCategoryReducer"
import updateCategoryReducer from "./event/updateCategoryReducer"
import deleteCategoryReducer from "./event/deleteCategoryReducer"
import fetchCategoryDetailsReducer from "./event/fetchCategoryDetailsReducer"

// User related reducers
import fetchUserReducer from "./fetchUserReducer"
import getSystemUserListReducer from "./getSystemUserListReducer"
import addSystemUserReducer from "./addSystemUserReducer"
import editSystemUserReducer from "./editSystemUserReducer"
import removeSystemUserReducer from "./removeSystemUserReducer"
import fetchUserDetailsReducer from "./fetchUserDetailsReducer"

// Pvs related reducers
import fetchPvsReducer from "./pvs/fetchPvsReducer"
import updatePvsReducer from "./pvs/updatePvsReducer"
import updatePvsCategoryReducer from "./pvs/updatePvsCategoryReducer"
import updatePvsSubcategoryReducer from "./pvs/updatePvsSubcategoryReducer"
import updatePvsKeywordReducer from "./pvs/updatePvsKeywordReducer"
import createPvsReducer from "./pvs/createPvsReducer"
import createPvsCategoryReducer from "./pvs/createPvsCategoryReducer"
import createPvsSubcategoryReducer from "./pvs/createPvsSubcategoryReducer"
import deletePvsReducer from "./pvs/deletePvsReducer"
import fetchPvsDetailReducer from "./pvs/fetchPvsDetailReducer"
import fetchPvsCategoryDetailReducer from "./pvs/fetchPvsCategoryDetailReducer"
import fetchPvsSubcategoryDetailReducer from "./pvs/fetchPvsSubcategoryDetailReducer"
import fetchPvsKeywordDetailReducer from "./pvs/fetchPvsKeywordDetailReducer"
import fetchPvsCategoryReducer from "./pvs/fetchPvsCategoryReducer"
import fetchPvsKeywordReducer from "./pvs/fetchPvsKeywordReducer"
import fetchPvsBrandReducer from "./pvs/fetchPvsBrandReducer"
import fetchPvsSubcategoryReducer from "./pvs/fetchPvsSubcategoryReducer"
import createPvsKeywordReducer from "./pvs/createPvsKeywordReducer"
import { update } from "lodash"
import updateUserReducer from "./updateUserReducer"
// All Bazaar List
import fetchAllBazaarListReducer from "./pvs/fetchAllBazaarListReducer"
import fetchStallListReducer from "./pvs/fetchStallListReducer"
import submitBookingReducer from "./pvs/submitBookingReducer"
import getOTPPVSReducer from "./getOTPPVSReducer"
import addBookingPaymentReducer from "./pvs/addBookingPaymentReducer"
import resendInvoiceReducer from "./pvs/resendInvoice"
import getUserBillingDetailsReducer from "./pvs/getUserBillingInfo"
import regenerateInvoiceReducer from "./pvs/RegenerateInvoice"
import downloadInvoicesReducer from "./pvs/downloadInvoices"
import downloadBookingReportReducer from "./pvs/downloadBookingReport"
import downloadBalanceReportReducer from "./pvs/downloadBalanceReport"
import downloadBazaarInterestListReducer from "./pvs/downloadBazaarInterestListReducer"
import addAwardNominationReducer from "./awards/addAwardNominationReducer"
import createOrderAwardNominationReducer from "./awards/createOrderAwardNominationReducer"
import verifyAwardNominationPaymentReducer from "./awards/verifyAwardNominationPaymentReducer"
import getAwardsListReducer from "./awards/getAwardsListReducer"
import getNominationListReducer from "./awards/getNominationListReducer"
import getNominationDetailsReducer from "./awards/getNominationDetailsReducer"
import getAwardsCategoryListReducer from "./awards/getCategoryListReducer"
import updateNominationReducer from "./awards/updateNominationReducer"
import addAwardShortlistedDetailsReducer from "./awards/addAwardShortlistedDetails"
import addAwardReducer from "./awards/addAwardReducer"
import editAwardReducer from "./awards/editAwardReducer"
import addAwardCategoryReducer from "./awards/addAwardCategoryReducer"
import editAwardCategoryReducer from "./awards/editAwardCategoryReducer"
import fetchKeywordsReducer from "./pvs/fetchKeywordsReducer"
import updatePvsRegistrationReducer from "./pvs/updatePvsRegistrationReducer"
import verifyPvsRegistrationPaymentReducer from "./pvs/verifyPvsRegistrationPaymentReducer"
import getPvsDetailsReducer from "./pvs/getPvsDetailsReducer"
import getBazaarStallDetailsReducer from "./pvs/getBazaarStallDetailsReducer"
import updateBazaarStallDetailsReducer from "./pvs/updateBazaarStallDetailsReducer"
import addBazaarReducer from "./pvs/addBazaarReducer"
import addBazaarStallDetailsReducer from "./pvs/addBazaarStallDetailsReducer"
import cancelStallBookingReducer from "./pvs/cancelStallBookingReducer"
import deleteAvailableStallReducer from "./pvs/deleteAvailableStallReducer"
import getPaymentStatisticsReducer from "./pvs/getPaymentStatisticsReducer"
import updateUserProfileReducer from "./updateUserProfileReducer"

// Product related reducers
import fetchProductsReducer from "./pvs/fetchProductsReducer"
import createProductReducer from "./pvs/createProductReducer"
import updateProductReducer from "./pvs/updateProductReducer"
import deleteProductReducer from "./pvs/deleteProductReducer"
import fetchProductDetailsReducer from "./pvs/fetchProductDetailsReducer"
import getBazaarInterestListReducer from "./pvs/getBazaarInterestListReducer"
import addBazaarInterestReducer from "./pvs/addBazaarInterestReducer"
import getBazaarDetailReducer from "./pvs/getBazaarDetailReducer"
import editBazaarReducer from "./pvs/editBazaarReducer"
import updateBazaarActiveStatusReducer from "./pvs/updateBazaarActiveStatusReducer"
import submitBazaarEnquiryReducer from "./pvs/submitBazaarEnquiryReducer"
import getBazaarEnquiryListReducer from "./pvs/getBazaarEnquiryListReducer"
import downloadBazaarEnquiryExcelReducer from "./pvs/downloadBazaarEnquiryExcelReducer"
import resendBazaarEnquiryWhatsappReducer from "./pvs/resendBazaarEnquiryWhatsappReducer"
import combineGroupBazaarListReducer from "./pvs/combineGroupBazaarListReducer"
import createEventBookingOrderReducer from "./event/createEventBookingOrderReducer"
import verifyEventPaymentReducer from "./event/verifyEventPaymentReducer"
// import createUserReducer from './createUserReducer';

//Pvs related
const pvsReducer = combineReducers({
  fetchKeywords: fetchKeywordsReducer,
  updatePvsRegistration: updatePvsRegistrationReducer,
  verifyPvsRegistrationPayment: verifyPvsRegistrationPaymentReducer,

  fetchPvs: fetchPvsReducer,
  fetchPvsCategory: fetchPvsCategoryReducer,
  fetchPvsSubcategory: fetchPvsSubcategoryReducer,
  fetchPvsKeyword: fetchPvsKeywordReducer,
  fetchPvsBrand: fetchPvsBrandReducer,

  createPvs: createPvsReducer,
  createPvsCategory: createPvsCategoryReducer,
  createPvsSubcategory: createPvsSubcategoryReducer,
  createPvsKeyword: createPvsKeywordReducer,

  updatePvs: updatePvsReducer,
  updatePvsCategory: updatePvsCategoryReducer,
  updatePvsSubcategory: updatePvsSubcategoryReducer,
  updatePvsKeyword: updatePvsKeywordReducer,

  fetchPvsDetail: fetchPvsDetailReducer,
  fetchPvsCategoryDetail: fetchPvsCategoryDetailReducer,
  fetchPvsSubcategoryDetail: fetchPvsSubcategoryDetailReducer,
  fetchPvsKeywordDetail: fetchPvsKeywordDetailReducer,
  fetchAllBazaarList: fetchAllBazaarListReducer,
  fetchStallList: fetchStallListReducer,
  submitBooking: submitBookingReducer,
  addBookingPayment: addBookingPaymentReducer,
  resendInvoice: resendInvoiceReducer,
  getUserBillingDetails: getUserBillingDetailsReducer,
  regenerateInvoice: regenerateInvoiceReducer,
  downloadInvoices: downloadInvoicesReducer,
  downloadBookingReport: downloadBookingReportReducer,
  downloadBalanceReport: downloadBalanceReportReducer,
  downloadBazaarInterestList: downloadBazaarInterestListReducer,

  deletePvs: deletePvsReducer,

  getPvsDetails: getPvsDetailsReducer,

  getBazaarStallDetails: getBazaarStallDetailsReducer,
  updateBazaarStallDetails: updateBazaarStallDetailsReducer,
  addBazaar: addBazaarReducer,
  addBazaarStallDetails: addBazaarStallDetailsReducer,
  cancelStallBooking: cancelStallBookingReducer,
  deleteAvailableStall: deleteAvailableStallReducer,
  getPaymentStatistics: getPaymentStatisticsReducer,

  // Product related
  fetchProducts: fetchProductsReducer,
  createProduct: createProductReducer,
  updateProduct: updateProductReducer,
  deleteProduct: deleteProductReducer,
  fetchProductDetails: fetchProductDetailsReducer,

  // Bazaar interest list
  getBazaarInterestList: getBazaarInterestListReducer,
  addBazaarInterest: addBazaarInterestReducer,

  // Bazaar edit
  getBazaarDetail: getBazaarDetailReducer,
  editBazaar: editBazaarReducer,
  updateBazaarActiveStatus: updateBazaarActiveStatusReducer,
  submitBazaarEnquiry: submitBazaarEnquiryReducer,
  getBazaarEnquiryList: getBazaarEnquiryListReducer,
  downloadBazaarEnquiryExcel: downloadBazaarEnquiryExcelReducer,
  resendBazaarEnquiryWhatsapp: resendBazaarEnquiryWhatsappReducer,

  // Combined group bazaar list
  combineGroupBazaarList: combineGroupBazaarListReducer,
})
//Event related
const eventReducer = combineReducers({
  // Event related
  fetchEvents: fetchEventsReducer,
  fetchEventDetails: fetchEventDetailsReducer,
  fetchEventTickets: fetchEventTicketsReducer,
  fetchEventTicketsExcel: fetchEventTicketsExcelReducer,
  createEvent: createEventReducer,
  updateEvent: updateEventReducer,
  deleteEvent: deleteEventReducer,
  createEventBookingOrder: createEventBookingOrderReducer,
  verifyEventPayment: verifyEventPaymentReducer,

  // Event Category related
  fetchCategories: fetchCategoriesReducer,
  fetchCategoryDetails: fetchCategoryDetailsReducer,
  createCategory: createCategoryReducer,
  updateCategory: updateCategoryReducer,
  deleteCategory: deleteCategoryReducer,
})

const awardsReducer = combineReducers({
  addAwardNomination: addAwardNominationReducer,
  createOrderAwardNomination: createOrderAwardNominationReducer,
  verifyAwardNominationPayment: verifyAwardNominationPaymentReducer,
  addAwardShortlistedDetails: addAwardShortlistedDetailsReducer,
  getAwardsList: getAwardsListReducer,
  getNominationList: getNominationListReducer,
  getNominationDetails: getNominationDetailsReducer,
  getAwardsCategoryList: getAwardsCategoryListReducer,
  updateNomination: updateNominationReducer,
  addAward: addAwardReducer,
  editAward: editAwardReducer,
  addAwardCategory: addAwardCategoryReducer,
  editAwardCategory: editAwardCategoryReducer,
})

// Combine all screen-related reducers
const screensReducer = combineReducers({
  // Auth related
  getOTP: getOTPReducer,
  getOTPPVS: getOTPPVSReducer,
  login: loginReducer,
  signup: signupReducer,
  getAdminDashboardData: getAdminDashboardDataReducer,
  getAllInvoices: getAllInvoicesReducer,
  updateUserProfile: updateUserProfileReducer,

  // User related
  fetchUsers: fetchUserReducer,
  fetchUserDetails: fetchUserDetailsReducer,
  updateUser: updateUserReducer,
  getSystemUserList: getSystemUserListReducer,
  addSystemUser: addSystemUserReducer,
  editSystemUser: editSystemUserReducer,
  removeSystemUser: removeSystemUserReducer,
  // createUser: createUserReducer,

  // Pvs related
  pvs: pvsReducer,

  // Event related
  event: eventReducer,

  // Awards related
  awards: awardsReducer,
})

export default screensReducer
